import { DateRangeField } from '@components/DateRangeField/DateRangeField';
import { useFormContext, useWatch } from 'react-hook-form';
import type { ReportFiltersValues } from '../../reportFilters.types';
import type { DateRangeFilterField as DateRangeFilterFieldConfig } from '../reportFiltersPanel.types';

interface DateRangeFilterFieldProps {
  field: DateRangeFilterFieldConfig;
}

export const DateRangeFilterField = ({
  field,
}: DateRangeFilterFieldProps): React.ReactElement => {
  const { control, setValue } = useFormContext<ReportFiltersValues>();
  const startDate = useWatch<ReportFiltersValues, typeof field.idFrom>({
    control,
    name: field.idFrom,
  });
  const endDate = useWatch<ReportFiltersValues, typeof field.idTo>({
    control,
    name: field.idTo,
  });

  return (
    <DateRangeField
      label={field.label}
      startDate={startDate}
      endDate={endDate}
      placeholder={field.placeholder}
      onValueChange={({ startDate: nextStart, endDate: nextEnd }) => {
        setValue(field.idFrom, nextStart);
        setValue(field.idTo, nextEnd);
      }}
    />
  );
};
